import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { canAccessRoute, getDefaultRoute } from '../../utils/roleAccess';

RoleGuard.propTypes = {
  path: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default function RoleGuard({ path, children }) {
  if (!canAccessRoute(path)) {
    return <Navigate to={getDefaultRoute()} replace />;
  }

  return children;
}
